import { injectable } from 'tsyringe';
import { JenjangApiRepository } from '../../app/repository/api/JenjangApiRepository';
import { Jenjang } from '../../entities/Jenjang';

@injectable()
export class JenjangPresenter {
  private repository: JenjangApiRepository;
  
  constructor(repository: JenjangApiRepository) {
    this.repository = repository;
  }

  public async getAllJenjang(): Promise<Jenjang[]> {
    return this.repository.getAllJenjang();
  }
}
